import React,{useEffect} from 'react'
// import DetailsThingComp from './../components/DetailsThingComp.js';
// import MapComp from './../components/MapComp.js';
// import DetailsReviewComp from './../components/DetailsReviewComp.js';
// import DetailsHostedComp from './../components/DetailsHostedComp.js';
// import BeforeFooter from './../components/BeforeFooter.js';
import DetailsImgComp from './../components/DetailsImgComp.js'
import DetailsCityComp from './../components/DetailsCityComp.js'
import DetailsMapComp from './../components/DetailsMapComp.js'
import DetailsDesc from './../components/DetailsDesc.js';
import DetailWholeSaleComp from './../components/DetailWholeSaleComp.js';
import DetailsFeatures from './../components/DetailsFeatures.js';
import DetailsTool from './../components/DetailsTool.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';

const DetailsPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
    },[])
    

  return (
      <section>
        <Header/>
        <br/>
        <br/>
        <DetailsImgComp/>
        <br/>

        <DetailsCityComp/>
        <br/>

        <DetailsDesc/>

        <DetailsFeatures/>
        <DetailsTool/>
        <DetailWholeSaleComp/>
        <DetailsMapComp />
        <Footer/>
    </section>
  )
}

export default DetailsPage